<script setup lang="ts">
import IconDocument from '~/components/icons/legal-content/IconDocument.vue'

defineOptions({
	name: 'IntroductionSection',
})

const { t: $t, locale } = useI18n()
const { $tThird } = useNuxtApp()

const firstHtml = computed(() => {
	return $tThird(
		'The following Terms & Conditions of Use {terms} outline the rules for accessing and using the Luckywise360 platform {platform}, made available by {company}, Lda., with registered office at {address}, having tax identification number {taxId}, registered with the Commercial Registry Office of {city} under the same number, with a share capital of € 600,000 euros (“{company}”).',
		{
			terms: `(“<span class="font-semibold">${$t('Terms & Conditions')}</span>”)`,
			platform: `(“<span class="font-semibold">${$t('Platform')}</span>”)`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
			address: '<span class="font-semibold">Rotunda Eng. Edgar Cardoso N23, Sala F</span>',
			taxId: '<span class="font-semibold">514677856</span>',
			city: '<span class="font-semibold">Vila Nova de Gaia</span>',
		},
	)
})

const secondHtml = computed(() => {
	return $tThird(
		`Users {users} must carefully read the following {terms} before using the {platform}, since it contains essential information regarding their rights and obligations, as well as conditions, limitations and exclusions that might apply to them.`,
		{
			users: `(“<span class="font-semibold">${$t('Users')}</span>”)`,
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
		},
	)
})

const thirdHtml = computed(() => {
	return $tThird(
		'By using the {platform}, clicking {accept} when prompted, or indicating their acceptance in an adjoining box, {users} confirm that they understand and agree to abide by all of these {terms}.',
		{
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			accept: `“<span class="italic">${$t('I Accept')}</span>”`,
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
		},
	)
})

const fourthHtml = computed(() => {
	return $tThird(
		'If {users} are accepting these {terms} on behalf of a company or another legal entity, they assert that have the legal authority to accept these {terms} on behalf of that entity, in which case {user} will refer to that entity. If {users} do not possess such authority, or if they do not agree with all of these {terms}, {company} will be unwilling to provide access to the {platform}.',
		{
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			user: `“<span class="italic">${$t('User')}</span>”`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const fiveHtml = computed(() => {
	return $tThird(
		'If {users} disagree with these {terms} or are prohibited by applicable law from accessing or using the {platform} or any of its contents, products, or services, they should refrain from accessing or using the {platform}.',
		{
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<IconDocument class="text-[#ED8B00] size-7" />
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">{{ $t('Introduction') }}</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-8">
			<p v-html="firstHtml"></p>
			<p v-html="secondHtml"></p>
			<p v-html="thirdHtml"></p>
			<p v-html="fourthHtml"></p>
			<p v-html="fiveHtml"></p>
		</div>
	</section>
</template>
